import CitySEOHead from "@/components/feature/CitySEOHead";
import BatonRougeHeroSection from "./components/HeroSection";
import BatonRougeStickyNav from "./components/StickyNav";
import BatonRougeProcessingTimeSection from "./components/ProcessingTimeSection";
import BatonRougeServicesSection from "./components/ServicesSection";
import BatonRougeLocalAreaSection from "./components/LocalAreaSection";
import BatonRougeTravelTimingSection from "./components/TravelTimingSection";
import BatonRougeDestinationsSection from "./components/DestinationsSection";
import BatonRougeTestimonialsSection from "./components/TestimonialsSection";
import BatonRougeAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import BatonRougeComparisonSection from "./components/ComparisonSection";
import BatonRougeMistakesSection from "./components/MistakesSection";
import BatonRougeHowItWorksSection from "./components/HowItWorksSection";
import BatonRougeFAQSection, { faqs } from "./components/FAQSection";
import BatonRougeHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import BatonRougeFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const batonRougeFaqs = faqs as { q: string; a: string }[];

const batonRougeServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function BatonRougePage() {
  return (
    <>
      <CitySEOHead
        city="Baton Rouge"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/baton-rouge"
        title="Emergency Passport Baton Rouge, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Baton Rouge, LA — as fast as 24 hours. LSU students, petrochemical workers, and state employees served. A+ BBB rated, registered State Dept. courier serving Baton Rouge, Zachary, Port Allen, and the Capital Region."
        geoPlacename="Baton Rouge, Louisiana"
        geoPosition="30.4515;-91.1871"
        faqs={batonRougeFaqs}
        servicesSchema={batonRougeServices}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <div className="font-sans">
        <BatonRougeHeroSection />
        <BatonRougeStickyNav />
        <BatonRougeProcessingTimeSection />
        <BatonRougeServicesSection />
        <BatonRougeLocalAreaSection />
        <BatonRougeTravelTimingSection />
        <BatonRougeDestinationsSection />
        <BatonRougeTestimonialsSection />
        <BatonRougeAcceptanceFacilitiesSection />
        <BatonRougeComparisonSection />
        <BatonRougeMistakesSection />
        <BatonRougeHowItWorksSection />
        <BatonRougeFAQSection />
        <BatonRougeHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/baton-rouge" state="LA" />
        <BatonRougeFinalCTA />
      </div>
    </>
  );
}